import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import useRequest from "../../../components/hooks/use-request";
import Navbar from "../../../components/layout/navbar";
import Icon from "../../../assets/icons";
import { showToast } from "../../../components/toast";
import { I_Profile } from "../../inventory/types";
import { RingLoader } from "react-spinners";
import { Plus, User } from "lucide-react";
import Button from "../../../components/button";
import RegionDetailsTable from "./details"
import AddOfficer from "./add-officer";



interface RegionData {
    _id: string;
    regionName: string;
    role_Id: string;
    sourcingOffice: string;
    email: string;
    phone: number;
    sourcingOfficers: any

}

const RegionDetails = () => {

    const [region, setRegion] = useState<RegionData>()
    const { id } = useParams<{ id: string }>();
    const [officerModal, setOfficerModal]= useState(false)
    const navigate = useNavigate()


    const [profile, setProfile] = useState<I_Profile | null>(null);
    const userToken = localStorage.getItem("token");
     const { makeRequest: getProfile } = useRequest("/users/profile", "GET", {
        Authorization: `Bearer ${userToken}`,
    });

    const { makeRequest: getRegionById } = useRequest(
        `/region/${id}`,
        "GET"
    );



    useEffect(() => {
        const fetchData = async () => {
          const [response] = await getRegionById();
          setRegion(response?.data?.region || []);
        };
        fetchData();
      }, []);

    useEffect(() => {
        const fetchProfile = async () => {
          const [response] = await getProfile();
          if (response.status) {
            setProfile(response.data?.user);
          }
        };
        fetchProfile();
    }, []);

    function closePromotionModal() {
        setOfficerModal(false);
      }
    
      function openPromotionModal() {
        setOfficerModal(true);
      }

    return ( 
        <div className="min-h-screen bg-gray-50 flex flex-col">
            <Navbar profile={profile as I_Profile} />

            <main className="flex-1 container mx-auto py-6">
                <div className="flex justify-between gap-5 mt-5 mx-10">
                    <div className="flex gap-4">
                        <div
                            onClick={() => navigate(-1)}
                            className="flex gap-2 font-semibold text-[16px] border-r-2 pr-4 border-separate cursor-pointer "
                        >
                            <Icon name="appbackIcon" className="mt-1" /> Back
                        </div>

                        <h1 className="md:text-[30px] -mt-2 font-bold">
                            {region?.regionName} Region
                        </h1>
                    </div>
                    

                    <div className="flex gap-2">
                        <button className="rounded-full border px-4 py-1">Export</button>

                        <Button
                            size="lg"
                            variant="primary"
                            type="button"
                            className="font-normal md:mt-0 mt-6"
                            onClick={openPromotionModal}
                        >
                        <User /> Add Officer
                        </Button>
                    </div>


                    

                    

                </div>

                <RegionDetailsTable data={region?.sourcingOfficers} />
            </main>
            

            <AddOfficer
                isVisible={officerModal}
                onClose={closePromotionModal}
                regions={region}
            />
        </div>
     );
}
 
export default RegionDetails;